import { ReloadOutlined } from '@ant-design/icons';
import { MIN_TOKEN_LENGTH_PG_TRGM } from '@medcom/shared-ui/utils/tokenSearch.ts';
import { Alert, Button, Flex, Tooltip } from 'antd';
import type React from 'react';
import { BEFUNDE_LIST } from '../../../utils/elementIds.ts';
import { PagedBefundeList } from './PagedBefundeList.tsx';
import { SearchField } from './SearchField.tsx';
import { useBefundListState } from './useBefundeListState.ts';
import { useBefundeListStyles } from './useBefundeListStyles.ts';

export const BefundeList: React.FC<{ myLabIdentifiers: string[] | undefined }> = ({ myLabIdentifiers }) => {
  const styles = useBefundeListStyles();

  const { state, nextPage, search, outdatedBefundIds, newBefundeAvailable, reload, droppedTokens, searchHasOnlyShortTokens } =
    useBefundListState(myLabIdentifiers);

  return (
    <Flex vertical className={styles.layout}>
      <SearchField value={state.search} onChange={search} />
      {droppedTokens.length > 0 && (
        <Alert
          showIcon
          type="warning"
          title={`Folgende Suchbegriffe sind zu kurz und werden ignoriert: ${droppedTokens.join(', ')} (mindestens ${MIN_TOKEN_LENGTH_PG_TRGM} Zeichen pro Wort)`}
          style={{ marginTop: 8, marginBottom: 8 }}
        />
      )}
      <div className={styles.reloadSection}>
        {newBefundeAvailable && (
          <Tooltip title="Neue Befunddaten verfügbar">
            <Button
              className={styles.reloadButton}
              color="blue"
              variant="filled"
              size="small"
              type="link"
              icon={<ReloadOutlined />}
              onClick={reload}
            >
              Neue Daten laden
            </Button>
          </Tooltip>
        )}
      </div>
      {!searchHasOnlyShortTokens && (
        <div id={BEFUNDE_LIST} className={styles.befundListWrapper}>
          <PagedBefundeList state={state} outdatedBefundIds={outdatedBefundIds} onNextPage={nextPage} />
        </div>
      )}
    </Flex>
  );
};
